import React, { useState } from 'react'
import { CriticalDeviationProps } from './interfaces';
import './CriticalDeviation.css';
import IconSave from '../Icons/IconSave/IconSave';
import { useTranslation } from 'react-i18next';

const CriticalDeviation: React.FC<CriticalDeviationProps> = ({ value, updateCriticalDeviation, disabled = false }) => {
  const inputStatusClassName = disabled ? 'c-critical-deviation_input_disabled max-w-8' : 'c-critical-deviation_input_active max-w-12';

  const { t } = useTranslation();

  const [currentValue, setCurrentValue] = useState<number>(value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setCurrentValue(Number(value));
  };

  const saveNewValue = async () => {
    await updateCriticalDeviation(currentValue);
  }

  return (
    <label style={{ display: 'none' }} className='c-critical-deviation min-h-9 inline-flex flex-row items-center border border-primary rounded overflow-hidden px-2 h-full gap-x-2'>
      <span className='text-sm font-medium text-nowrap'>{t('screen.commonText.criticalDeviation')}:</span>
      <input
        disabled={disabled}
        type='number'
        name='critical_deviation'
        value={currentValue}
        onChange={handleChange}
        className={`c-critical-deviation_input ${inputStatusClassName} relative top-[1px] text-xs text-center appearance-none h-full w-full border border-stroke rounded outline-none truncate`}
      />
      {!disabled && (
        <button onClick={saveNewValue} className='p-1 bg-primary rounded border border-primary text-white active:text-primary active:border-inherit active:bg-white'>
          <IconSave height={10} width={10} iconClassName='text-inherit' />
        </button>
      )}
    </label>
  )
};

export default CriticalDeviation;
